import React, { useState, useEffect } from "react";
import Header from "common/js/header/header";
import 'common/css/master.css';
import "../css/studentReport.css";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import StudentReportTable from "./studentReportTable";

const StudentReport = () => {

    const [loader, setLoader] = useState("none");
    const [opacity, setOpacity] = useState(1);

    useEffect(() => {
        // console.log("StudentReport (StudentReportCtrl.js) called");
    }, []);


    return (
        <div>
            <Header />
            <ToastContainer autoClose={3000} hideProgressBar />
            <div style={{ position: 'fixed', zIndex: 10000, width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '50%', top: '50%', display: loader }}>
                <img className="loderImg" src={require("common/images/loader.gif")} alt="Loader..." />
            </div>

            <div className="mainContainer" style={{ opacity: opacity }}>
                <div className="col-xs-10 col-centered padding-remove">
                    <div className="col-xs-12 padding-remove">
                    </div>
                    <div className="col-xs-12 padding-remove">
                        <StudentReportTable
                            setLoader={setLoader}
                            setOpacity={setOpacity}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
export default StudentReport;